import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import {
  assignToListIcon,
  assignToListIconRed,
  InfluencerRating,
} from "../../Components";
import { storageHandler, utils } from "../../Helpers";
import {
  Table,
  TableBody,
  TableHead,
  TableContainer,
  Paper,
  TableCell,
  TableRow,
} from "@mui/material";
import { ChartLine } from "lucide-react";

export default function ListInfluencerSearch(props) {
  console.log("props.influncerList", props.influncerList);
  const [expandedRows, setExpandedRows] = useState({});

  const navigate = useNavigate();

  let userData = null;
  try {
    const userInfo = storageHandler.getUserInfo();
    if (userInfo) {
      const parsed = JSON.parse(userInfo);
      userData = parsed?.data || null;
    }
  } catch (error) {
    console.error("Error parsing user info:", error);
  }

  const showInfProfile = async (event, influencer) => {
    console.log("showInfProfile called", { props, userData, influencer });
    if (
      props &&
      props.isUserHasSubscription &&
      userData &&
      userData.p_f_ids &&
      userData.p_f_ids.includes(1)
    ) {
      storageHandler.setUserTypeForProfileItem(JSON.stringify(influencer.type));
      navigate("/brand/influencerProfile/" + influencer.id);
    } else {
      if (props && props.setIsSubscribeModal) {
        props.setIsSubscribeModal(true);
      }
    }
  };

  const getStringOfBio = (influencer) => {
    return influencer.bio
      ? influencer.bio !== ""
        ? utils.testJSON(influencer.bio)
          ? utils.draftJsFormatingForDetailsBio({
              data: influencer.bio,
              view: "lessview",
            })
          : influencer.bio.substring(0, 25)
        : ""
      : "";
  };
  const userDisplayFormat = (count) => {
    if (count >= 1000000000)
      return (count / 1000000000).toFixed(1).replace(/\.0$/, "") + "B";

    if (count >= 1000000)
      return (count / 1000000).toFixed(1).replace(/\.0$/, "") + "M";

    if (count >= 1000)
      return (count / 1000).toFixed(1).replace(/\.0$/, "") + "K";

    return count;
  };

  const confirmRemoveFromList = async (event, influencer) => {
    event.stopPropagation();
    props.setSelectedInfluencer(influencer);
    props.setModal("confirmDelete");
  };

  const chkLoginandActionAccordingly = (event, influencer) => {
    event.stopPropagation();
    if (props.isUserHasSubscription && userData.p_f_ids.includes(1)) {
      if (props.profiles !== undefined) {
        if (props.isUserHasSubscription === true) {
          props.setSelectedInfluencer(influencer);
          props.setModal("addtoList");
        } else {
          props.setIsUserHasAccessListing(false);
        }
      } else {
        navigate("/account/pricing");
      }
    } else {
      props.setIsSubscribeModal(true);
    }
  };
  return (
    <>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          overflowX: "auto",
          width: "100%",
          boxShadow: "none",
          border: "none",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "20px",
        }}
      >
        <Table>
          <TableHead className="">
            <TableRow>
              <TableCell
                sx={{
                  py: 1,
                  pl: 0,
                  maxWidth: "400px",
                  minWidth: "150px",
                  font: "bold",
                }}
              >
                {props.influncerList.length} influencers founds
              </TableCell>
              <TableCell
                sx={{
                  py: 1,
                  px: 2,
                  textAlign: "center",
                  color: "#4b5563",
                  minWidth: "100px",
                }}
              >
                Rating
              </TableCell>
              <TableCell colSpan={4} sx={{ py: 1, px: 2, color: "#4b5563" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ flex: "0 0 25%", textAlign: "center" }}>
                    Platform
                  </div>
                  <div style={{ flex: "0 0 25%", textAlign: "center" }}>
                    Followers
                  </div>
                  <div style={{ flex: "0 0 25%", textAlign: "center" }}>
                    Following
                  </div>
                  <div style={{ flex: "0 0 25%", textAlign: "center" }}>
                    Engagement Rate
                  </div>
                </div>
              </TableCell>
              <TableCell
                sx={{ py: 1, pr: 0, textAlign: "right", color: "#4b5563" }}
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.influncerList.map((item, index) => (
              <TableRow
                key={index}
                className="text-gray-500"
                sx={{
                  borderBottom:
                    index === props.influncerList.length - 1
                      ? "none"
                      : "1px solid #e5e7eb",
                }}
              >
                <TableCell
                  sx={{
                    maxWidth: "200px",
                    minWidth: "150px",
                    pl: 0,
                    borderBottom:
                      index === props.influncerList.length - 1
                        ? "none"
                        : "none",
                    verticalAlign: "middle",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <img
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                      }}
                      src={
                        item.profile_img_url &&
                        item.profile_img_url &&
                        item.profile_img_url !== ""
                          ? item.profile_img_url
                          : `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
                      }
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
                      }}
                      alt="avatar"
                      onClick={(e) => showInfProfile(e, item)}
                    />
                    <span className="pt-1">
                      <div onClick={(e) => showInfProfile(e, item)}>
                        {item.display_name}
                      </div>
                      {/* {item.bio && item.bio !== "" && (
                        <div
                          className="bio-text-gray"
                          style={{
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            fontSize: "14px",
                          }}
                        >
                          {utils.testJSON(item.bio)
                            ? utils.draftJsFormatingForDetailsBio({
                                data: item.bio,
                                view: "fullview",
                              })
                            : item.bio}
                        </div>
                      )} */}
                      {item.bio && item.bio !== "" && (
                        <div className="tags">
                          <p className="tagstext bio-text-gray">
                            {item.bio
                              ? getStringOfBio(item) !== ""
                                ? getStringOfBio(item)
                                : ""
                              : ""}
                          </p>
                        </div>
                      )}
                    </span>
                  </div>
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom:
                      index === props.influncerList.length - 1
                        ? "none"
                        : "none",
                    px: 2,
                    minWidth: "100px",
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  <div style={{ display: "inline-block" }}>
                    <InfluencerRating
                      infrating={item.rating}
                    ></InfluencerRating>
                  </div>
                </TableCell>
                <TableCell
                  colSpan={4}
                  sx={{
                    borderBottom:
                      index === props.influncerList.length - 1
                        ? "none"
                        : "none",
                    px: 2,
                    verticalAlign: "middle",
                  }}
                >
                  <div>
                    {item.social_accounts
                      ?.slice(0, expandedRows[index] ? undefined : 2)
                      .map((account, idx) => (
                        <div
                          key={idx}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom:
                              idx <
                              (expandedRows[index]
                                ? item.social_accounts.length
                                : Math.min(2, item.social_accounts.length)) -
                                1
                                ? "8px"
                                : "0",
                          }}
                        >
                          <div
                            style={{
                              flex: "0 0 25%",
                              textAlign: "center",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {account.platform === "IG" && (
                              <img
                                src="images/instagram.svg"
                                width="28"
                                title="instagram"
                                alt="Instagram"
                              />
                            )}
                            {account.platform === "FB" && (
                              <img
                                src="images/facebook.svg"
                                width="28"
                                title="facebook"
                                alt="Facebook"
                              />
                            )}
                            {account.platform === "YT" && (
                              <img
                                src="images/youtube.svg"
                                width="28"
                                title="youtube"
                                alt="YouTube"
                              />
                            )}
                            {account.platform === "TT" && (
                              <img
                                src="images/tiktok-logo.svg"
                                width="28"
                                title="tiktok"
                                alt="TikTok"
                              />
                            )}
                          </div>
                          <div
                            style={{
                              flex: "0 0 25%",
                              textAlign: "center",
                              color: "#4b5563",
                            }}
                          >
                            {account.followers === 0
                              ? "0"
                              : userDisplayFormat(account.followers) || "-"}
                          </div>
                          <div
                            style={{
                              flex: "0 0 25%",
                              textAlign: "center",
                              color: "#4b5563",
                            }}
                          >
                            {account.following === 0
                              ? "0"
                              : userDisplayFormat(account.following) || "-"}
                          </div>
                          <div
                            style={{
                              flex: "0 0 25%",
                              textAlign: "center",
                              color: "#4b5563",
                            }}
                          >
                            {account.engagement_rate === 0
                              ? "0"
                              : account.engagement_rate || "-"}
                          </div>
                        </div>
                      )) || "-"}
                    {item.social_accounts?.length > 2 && (
                      <button
                        onClick={() =>
                          setExpandedRows((prev) => ({
                            ...prev,
                            [index]: !prev[index],
                          }))
                        }
                        style={{
                          fontSize: "12px",
                          color: "#9CA3AF",
                          cursor: "pointer",
                          background: "none",
                          border: "none",
                          padding: 0,
                          marginTop: "8px",
                          verticalAlign: "middle",
                          marginLeft: "35px",
                        }}
                      >
                        {expandedRows[index]
                          ? "View Less"
                          : `+${item.social_accounts.length - 2} More`}
                      </button>
                    )}
                  </div>
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom:
                      index === props.influncerList.length - 1
                        ? "none"
                        : "none",
                    pr: 0,
                    textAlign: "right",
                    verticalAlign: "middle",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      justifyContent: "flex-end",
                    }}
                  >
                    {props.profiles === undefined ? (
                      <button
                        className="w-14 h-14 border-green-600 border rounded-lg flex !justify-center items-center"
                        onClick={(e) => chkLoginandActionAccordingly(e, item)}
                      >
                        <div className="like-icon">{assignToListIcon}</div>
                      </button>
                    ) : item.list_id !== "" ? (
                      <button
                        className="w-14 h-14 border-green-600 border rounded-lg flex !justify-center items-center"
                        onClick={(e) => confirmRemoveFromList(e, item)}
                      >
                        <div className="like-icon">{assignToListIconRed}</div>
                      </button>
                    ) : (
                      <button
                        className="w-14 h-14 border-green-600 border rounded-lg flex !justify-center items-center"
                        onClick={(e) => chkLoginandActionAccordingly(e, item)}
                      >
                        <div className="like-icon">{assignToListIcon}</div>
                      </button>
                    )}

                    <button
                      className="w-14 h-14 bg-green-600 border rounded-lg flex !justify-center items-center"
                      onClick={(e) => showInfProfile(e, item)}
                    >
                      <ChartLine className="text-white" />
                    </button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
